import { Button } from '@/components/ui/button';
import { Card, CardContent, CardTitle } from '@/components/ui/card';
import { Bucket } from './budget-data';
import { useCurrencyFormatter } from '@liquidbudget/common';

type Props = { bucket: Bucket };

export function BucketCard({ bucket }: Props) {
  const formatCurrency = useCurrencyFormatter();

  return (
    <Card className="w-full dark:bg-gray-800">
      <div className="flex flex-col items-center justify-center pt-4 pb-2">
        <div className="space-y-1 text-center">
          <CardTitle>{bucket.name}</CardTitle>
        </div>
      </div>
      <CardContent className="mt-2 mb-2 pb-0 flex justify-center">
        <Button variant="active" size="sm" className="text-sm mb-2">
          {formatCurrency(bucket.assigned)}
        </Button>
      </CardContent>
    </Card>
  );
}
